import React from 'react';
import PageList from '../../../components/PageListAPI'
import { getCompanies, deleteCompanies } from '../../../api/list'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';

export default function Companies(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='companiesList'
        columns={[{ id: 'fullName', name: 'Наименование' }]}
        createItem={can(SLUGS.CATALOG.CREATE)}
        deleteItem={can(SLUGS.CATALOG.DELETE)}
        loadAPI={{
          request: getCompanies,
        }}
        title='Компании'
        deleteAPI={deleteCompanies}
        {...props}
      />
    </div>
  )
};